import { useEffect, useState } from 'react';
import { Input, Textarea } from '@nimbus-ds/components';
import { CATALOG_MF_OPEN_AS_TEXTAREA } from 'App/featuresFlags';
import { useHasTags } from 'App/hooks';
import { ItemProps } from 'domains/Metafields/components/MetafieldInput/types';
import { useTranslationsMetafields } from 'domains/Metafields/hooks';

function TextItem({
  metafield,
  disabled,
  value,
  onChange,
  onUpdate,
}: ItemProps) {
  const [internalValue, setInternalValue] = useState(value);
  const [hasTextArea] = useHasTags([CATALOG_MF_OPEN_AS_TEXTAREA]);
  const t = useTranslationsMetafields();
  const placeholder = t('assignMetafieldsForm.placeholders.textOrNumber');

  const handleChange = ({ target: { value } }) => {
    setInternalValue(value);
    onChange?.(value);
  };

  const handleBlur = ({ target: { value } }) => {
    setInternalValue(value);
    onUpdate?.(value || null);
  };

  useEffect(() => {
    setInternalValue(value);
  }, [value]);

  const Component = hasTextArea ? Textarea : Input;
  return (
    <Component
      disabled={disabled !== undefined ? disabled : metafield.disabled}
      id={metafield.id}
      name={metafield.name}
      value={internalValue}
      onChange={handleChange}
      onBlur={handleBlur}
      placeholder={placeholder}
      lines={(internalValue ?? '').split('\n').length}
      maxLength={250}
    />
  );
}

export default TextItem;
